import { render, staticRenderFns } from "./EditAreas.vue?vue&type=template&id=30818498&"
import script from "./EditAreas.vue?vue&type=script&lang=js&"
export * from "./EditAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports